/**
 * Labstep
 *
 * @module components/Entity/Action/AddSearch/WithoutModal
 * @desc Search select to add an entity
 */

import { Can } from 'labstep-web/components/Entity/Can';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { EntityToggleContainer } from 'labstep-web/containers/Entity/Toggle';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import type React from 'react';
import type { EntityActionAddSearchWithoutModalProps } from './types';

export const EntityActionAddSearchWithoutModal: React.FC<
  EntityActionAddSearchWithoutModalProps
> = ({
  parentEntity,
  entityName,
  activeGroup,
  extraParams,
  placeholder,
  autoFocus = true,
}) => (
  <Can
    entityName={parentEntity.entityName}
    id={parentEntity.idAttr}
    action={
      entityName === 'folder'
        ? (`folder_${parentEntity.entityName}:${Action.add_remove}` as Action)
        : (`${entityName}:${Action.add_remove}` as Action)
    }
  >
    <EntityToggleContainer
      action="add"
      entityName={entityName}
      parentName={parentEntity.entityName}
      parentId={parentEntity.id}
    >
      {({ toggle }) => (
        <SearchSelect
          labelKey="name"
          autoFocus={autoFocus}
          openMenuOnFocus
          creatable
          createBody={{
            type: parentEntity.entityName,
            ...extraParams,
          }}
          params={{
            group_id: activeGroup?.id,
            type: parentEntity.entityName,
            ...extraParams,
          }}
          placeholder={placeholder}
          entityName={entityName}
          value={null}
          onChange={(selectedOption) => {
            toggle(undefined, selectedOption.guid, {
              toast: true,
            });
          }}
        />
      )}
    </EntityToggleContainer>
  </Can>
);

export default withActiveGroup(EntityActionAddSearchWithoutModal);
